// This import loads the firebase namespace along with all its type information.
import MobileCredentials from './mobile-credentials-model'

export async function load_mobileCredentialss(): Promise<MobileCredentials[]> {
  throw 'Not implemented'
}

export async function delete_mobileCredentials(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mobileCredentials(): Promise<MobileCredentials> {
  throw 'Not implemented'
}
